/** CMS sentinel: `/`, `_`, or bare site origin means "canonical = current page URL". */
export const isCmsSelfCanonical = (canonical: string, siteOrigin = ''): boolean => {
    if (canonical === '/' || canonical === '_') {
        return true;
    }

    if (!siteOrigin) {
        return false;
    }

    const origin = siteOrigin.replace(/\/$/, '');

    return canonical === origin || canonical === `${origin}/`;
};
